import React from 'react'
import Button from 'components/Button'

export default function ActionButton({ color, children, onClick }) {
	return (
		<Button variant="ghost" size="small" onClick={onClick} className="min-w-0 m-0.5 p-1">
			{children}
		</Button>
	)
}
